import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ShareOptions = ({ projectId = "proj_abc123" }) => {
  const [shareLink, setShareLink] = useState("");
  const [linkGenerated, setLinkGenerated] = useState(false);
  const [copied, setCopied] = useState(false);

  const generateShareLink = () => {
    const mockLink = `https://giati-builder.app/shared/${projectId}`;
    setShareLink(mockLink);
    setLinkGenerated(true);
  };

  const copyToClipboard = () => {
    navigator.clipboard?.writeText(shareLink)?.then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const shareOptions = [
    { name: "Email", icon: "Mail", color: "text-blue-400" },
    { name: "Slack", icon: "MessageSquare", color: "text-purple-400" },
    { name: "GitHub", icon: "Github", color: "text-gray-400" },
    { name: "Twitter", icon: "Twitter", color: "text-sky-400" }
  ];

  return (
    <div className="bg-card rounded-lg p-4 md:p-6 border border-border">
      <h3 className="text-base md:text-lg font-semibold mb-4 flex items-center gap-2">
        <Icon name="Share2" size={20} className="text-accent" />
        Share Project
      </h3>
      {!linkGenerated ? (
        <div className="space-y-4">
          <p className="text-sm md:text-base text-muted-foreground">
            Generate a shareable link to collaborate with your team or showcase your project.
          </p>
          <Button
            variant="default"
            fullWidth
            iconName="Link"
            iconPosition="left"
            onClick={generateShareLink}
          >
            Generate Share Link
          </Button>
        </div>
      ) : (
        <div className="space-y-4">
          <div className="flex gap-2">
            <input
              type="text"
              value={shareLink}
              readOnly
              className="flex-1 px-3 py-2 bg-muted border border-border rounded-md text-sm md:text-base focus:outline-none focus:ring-2 focus:ring-ring"
            />
            <Button
              variant="outline"
              size="default"
              iconName={copied ? "Check" : "Copy"}
              onClick={copyToClipboard}
              className="flex-shrink-0"
            >
              {copied ? "Copied!" : "Copy"}
            </Button>
          </div>

          <div className="pt-4 border-t border-border">
            <p className="text-sm md:text-base text-muted-foreground mb-3">Share via:</p>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 md:gap-3">
              {shareOptions?.map((option, index) => (
                <button
                  key={index}
                  className="flex flex-col items-center justify-center gap-2 p-3 md:p-4 bg-muted hover:bg-muted-foreground/10 rounded-md transition-colors min-h-[80px]"
                  aria-label={`Share via ${option?.name}`}
                >
                  <Icon name={option?.icon} size={20} className={option?.color} />
                  <span className="text-xs md:text-sm font-medium">{option?.name}</span>
                </button>
              ))}
            </div>
          </div>

          <div className="flex items-start gap-2 p-3 bg-muted rounded-md">
            <Icon name="Info" size={16} className="text-muted-foreground flex-shrink-0 mt-0.5" />
            <p className="text-xs md:text-sm text-muted-foreground">
              Share links expire after 7 days. Recipients can view and download the project.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ShareOptions;